import(/* webpackMode: "eager", webpackExports: ["LocaleLink"] */ "/app/src/i18n/provider.tsx");
